import { useState } from "react";

import { Button, ModalDelete } from "expano-components";

import { Main, PageLoader, Error } from "components";
import useGet from "hooks/useGet";
import useDelete from "hooks/useDelete";

import { ReactComponent as ProductIcon } from "icons/product.svg";

import BasicData from "./components/BasicData";
import Brands from "./components/Brands";
import MarketplaceData from "./components/MarketplaceData";

const ProducerEdit = ({
  match: {
    params: { id },
  },
  history,
}) => {
  const [show_delete_modal, setShowDeleteModal] = useState(false);

  const {
    is_loading,
    is_error,
    error,
    data: producer,
    refetch,
  } = useGet({
    query: ["producer", id],
    path: `/producers/${id}`,
    context: "ui_show",
  });

  const { is_deleting, _delete } = useDelete({
    path: `/producers/${id}`,
    onSuccess: () => history.push("/producers"),
  });

  if (is_loading) {
    return <PageLoader />;
  }

  if (is_error) {
    return <Error message={error} />;
  }

  return (
    <Main
      page={{
        name: producer?.name,
        icon: <ProductIcon />,
        breadcrumbs: [
          {
            name: "Producenci",
            path: "/producers",
          },
          { name: producer?.name },
        ],
        buttons: (
          <Button
            type="delete"
            text="Usuń producenta"
            disabled={is_deleting}
            onClick={() => setShowDeleteModal(true)}
          />
        ),
      }}
    >
      {show_delete_modal && (
        <ModalDelete
          handleDelete={_delete}
          handleClose={() => setShowDeleteModal(false)}
          name={`producenta ${producer?.name}?`}
        />
      )}
      <div className="dashboard-wrapper-flex">
        <div className="column-half">
          <BasicData
            producer_id={id}
            refetch={refetch}
            initialValues={{
              name: producer?.name,
            }}
          />
          <MarketplaceData
            producer_id={id}
            refetch={refetch}
            initialValues={{
              allegro_responsible_producer_name:
                producer?.allegro_responsible_producer_name,
              erli_responsible_producer_name:
                producer?.erli_responsible_producer_name,
              amazon_gpsr_manufacturer_email:
                producer?.amazon_gpsr_manufacturer_email,
            }}
          />
        </div>
        <div className="column-half">
          <Brands producer_id={id} data={producer?.brands} refetch={refetch} />
        </div>
      </div>
    </Main>
  );
};

export default ProducerEdit;
